/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'manufacture-date': {
    width: 41,
    height: 40,
    viewBox: '0 0 41 40',
    data: '<g clip-path="url(#clip0_10649_29007)"><path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M27.813 1.75H40.75v37.021H.25V24.307l7.143-11.04 4.308 6.731 4.549-6.69 4.25 6.64 4.26-6.656 3.053 4.58V1.75zm2.5 2.5v21.878l-5.51-8.265-4.303 6.724-4.313-6.74-4.55 6.69-4.255-6.65-4.632 7.158v11.226h35.5V4.25h-7.937z" _fill="#1F222C"/></g><defs><clipPath id="clip0_10649_29007"><path pid="1" _fill="#fff" transform="translate(.5)" d="M0 0h40v40H0z"/></clipPath></defs>'
  }
})
